import React, { useState, useEffect } from "react";
import Dropdown from "./dropdown";
import InputTextBox from "./input-textbox";
import Date from "./date-picker";
import axios from "axios";
// import Modal from 'react-modal';
import './preview-form.css';
import Snackbar from "../shared/snackbar"
import RadioInput from "./radio-group";
import TextArea from "./textarea"

const Preiewfrom = () => {
    const queryParam = window.location.pathname.split('forms/')[1].split('/');
    const [formErrors, setFormErrors] = useState({});
    const [formValues, setFormValues] = useState({});
    const [formInput, setFormInput] = useState([]);
    const [snackBarMsg, setSnackbarMsg] = useState({})
    const [responseData, setData] = useState({});
    // const api_url = process.env.REACT_APP_API_BASE_URL
    // const api_url = 'https://apps.i9f.me/builder/api/v1'
    // var api_url = 'https://apps.infn.in/builder/api/v1' //Temp. solution for production only(need to fix this for staging as well)
    // const api_url = 'https://event-staging.goinfinito.com/builder/api/v1'
    // https://apps.i9f.me/builder/api/v1
    var api_url = '';

    useEffect(() => {
        api_url = window.location.origin + '/builder/api/v1';
        const url = `${api_url}/forms/` +queryParam[0] + '/' +queryParam[1]
        axios.get(url).then(res => {
            if (res['data']['success']) {
                if(res['data']['data']['company_name']) {
                    document.title = res['data']['data']['company_name'];
                }
                setData(res['data']['data'])
                setFormInput(res['data']['data']['form_fields'])
            }
        }).catch(err => {

        })
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault();
        api_url = window.location.origin + '/builder/api/v1';
        const url = api_url + `/form-responses/${queryParam[1]}`
        const body = {
            form_response: formValues,
        }
        axios.put(url, body).then(res => {
            if (res['data']['success']) {
                setSnackbarMsg({ msg: res['data']['message'], severity: 'success' });
                let url = res['data']['data']['redirect_url']
                window.location.assign(url.includes('http://') || url.includes('https://') ? url : `http://${url}`);
            } else {
                setSnackbarMsg({ msg: res['data']['message'], severity: 'error' });
                setFormErrors(validate(res['data']['data']));
            }
        }).catch(err => {
            // setSnackbarMsg({ msg: err['response']['data']['data']['errors'], severity: 'error' });
        })
    }

    const validate = (values) => {
        const errorMessage = {};
        values.filter(msg => {
            errorMessage[msg['key']] = msg['value'];
        })

        return errorMessage;
    }

    const RenderFormElements = (formField) => {
        const { type, input } = formField;
        // obj[input] = formValues[input];
        const handleChange = (e) => {
            const { value } = e.target;
            formValues[input] = value
            // setFormValues({ ...formValues, [input]: value });
        }

        const formInputsProps = {
            formValues, setFormValues, formErrors, handleChange, formField, responseData
        }

        switch (type) {
            case "textbox":
                return <InputTextBox formInputsProps={formInputsProps} />
            case "multiple_select":
            case "single_select":
                return <Dropdown formInputsProps={formInputsProps} />
            case "date":
                return <Date formInputsProps={formInputsProps} />
            case "radio_button":
                return <RadioInput formInputsProps={formInputsProps} />
            case "textarea":
                return <TextArea formInputsProps={formInputsProps} />
            default:
                return
        }
    }

    return (
        // <Modal isOpen={true} style={modalStyles} >

        <div className={`previewform_main ${responseData.theme}_preview_wrapper`}>
            {snackBarMsg?.msg && <Snackbar snackBarMsg={snackBarMsg} setSnackbarMsg={setSnackbarMsg} />}
            <form onSubmit={handleSubmit}>
                <div className="previewForm_outerSec">
                    <div className="header_sec">
                        {!responseData.company_name ? <img className="logo" src={responseData.form_company_logo} alt="logo" /> : <strong>{responseData.company_name}</strong>}
                        {/* <img src={require(`../../images/logo.png`)} alt="logo" /> */}
                    </div>
                    <div className="previewForm_innerSec">
                        <div className="main-heading">
                            {/* <p className="connect-heading">Connect with you</p>
                            <p className="fillDetails-heading">Please fill the following details</p> */}
                        </div>
                        <div className="row">
                            {
                                formInput.map(item => { return RenderFormElements(item) })
                            }

                            <div className="col-12">
                                { 
                                    queryParam[0] == 's' ? 
                                        <button className={`btn btn-design ${responseData.theme}_submit`} type="submit">Submit</button> : 
                                    null
                                }
                            </div>
                        </div>
                    </div>
                    <div className="about_desc">
                        <h5>About Us</h5>
                        <p>
                            {responseData.about_company}
                            </p>
                    </div>
                </div>
            </form>
        </div>
        // </Modal>
    )
}
export default Preiewfrom









